export default async function (ctx, inject) {
  const icons = {"64x64":"/static/icons/icon_64x64.6b17fa.png","120x120":"/static/icons/icon_120x120.6b17fa.png","144x144":"/static/icons/icon_144x144.6b17fa.png","152x152":"/static/icons/icon_152x152.6b17fa.png","192x192":"/static/icons/icon_192x192.6b17fa.png","384x384":"/static/icons/icon_384x384.6b17fa.png","512x512":"/static/icons/icon_512x512.6b17fa.png"}
  const getIcon = size => icons[size + 'x' + size] || ''
  inject('icon', getIcon)
}
